export default __webpack_public_path__ + "static/email_address_zoho-2f7be1203005c6fbd66c86c6a7809634.svg";